import React from 'react';
import './ServiceManager.less';
import { Button, Input, Modal, Select, Switch, Table, Tabs } from 'antd';
import { Btn, OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';
import { PATHS, SVC_AUDIT_TYPE } from '../../utils/constants';
import _ from 'lodash';
import * as routerRedux from 'react-router-redux';
import CleaningManage from '../../routes/SystemConfig/CleaningManage'

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const GRADE_TAB = '1';
const ITEM_TAB = '2';

//会议室服务管理
class ServiceManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: GRADE_TAB,
      currentDetailObj: {},
      showCleanerManage: false
    };
  }

  render() {
    const { activeKey, showCleanerManage } = this.state;
    const { intl, serviceModal, svcEditObj, dispatch } = this.props;
    let btnText = '',modalTitle = '',cleaningManageTitle='';
    if (activeKey === GRADE_TAB) {
      btnText = intl.formatMessage({ id: 'service_new_level' });
      modalTitle = intl.formatMessage({ id: 'service_item_manage' });
      cleaningManageTitle = intl.formatMessage({ id: 'service_cleaning_manage_title' });
    } else if (activeKey === ITEM_TAB) {
      btnText = intl.formatMessage({ id: 'service_new_item' });
      modalTitle = svcEditObj.id
        ? intl.formatMessage({ id: 'service_edit_item' })
        : intl.formatMessage({ id: 'service_new_item' });
      cleaningManageTitle = intl.formatMessage({ id: 'service_cleaning_manage_title' });
    }
    return (
      <div className="service-container">
        {
          showCleanerManage ?  <div >
              <CleaningManage activeKey = {activeKey} onClick={()=>{
                this.setState({showCleanerManage: false});
            }}/>
          </div>
            :
            <Tabs
              type="card"
              activeKey={activeKey}
              onChange={activeKey => this.setState({ activeKey: activeKey })}
            >
              <TabPane
                key={GRADE_TAB}
                tab={intl.formatMessage({ id: 'service_level' })}
              >
                {this.gradeTab()}
              </TabPane>
              <TabPane
                key={ITEM_TAB}
                tab={intl.formatMessage({ id: 'service_item' })}
              >
                {this.itemTab()}
              </TabPane>
            </Tabs>
        }

        <div className="service-btns">
          {!showCleanerManage && cleaningManageTitle && (
            <Button
              className="clean-manage"
              onClick={() => {
                this.setState({showCleanerManage: true})
              }}
            >
              {cleaningManageTitle}
            </Button>
          )}
          {!showCleanerManage && btnText && (
            <Button
              type="primary"
              icon="plus"
              className="new-btn"
              onClick={() => this.showModal({})}
            >
              {btnText}
            </Button>
          )}
        </div>

        <Modal
          wrapClassName="service-manage-wrapper modal-close-header"
          visible={serviceModal}
          title={modalTitle}
          onCancel={() => this.closeModal()}
          footer={
            <div className="service-manage-footer">
              <Btn onClick={() => this.closeModal()}>
                {intl.formatMessage({ id: 'dialog_btn_cancel' })}
              </Btn>
              <Btn primary onClick={() => this.submit()}>
                {intl.formatMessage({ id: 'dialog_btn_ok' })}
              </Btn>
            </div>
          }
        >
          {activeKey === GRADE_TAB && this.gradeModal()}
          {activeKey === ITEM_TAB && this.itemModal()}
        </Modal>
      </div>
    );
  }

  /**
   * 服务等级tab
   * @returns {*}
   */
  gradeTab = () => {
    const { intl, serviceLevels = [] } = this.props;
    const gradeColumns = [
      {
        title: intl.formatMessage({ id: 'service_level' }),
        dataIndex: 'name',
        key: 'name',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_Exchange_describe' }),
        dataIndex: 'remark',
        key: 'remark',
        width: '60%'
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_operation' }),
        dataIndex: 'operation',
        key: 'operation',
        width: '20%',
        render: (text, record) => {
          return (
            <div className="user-operate">
              <OperateSpan onClick={() => this.showModal(record)}>
                <IconTip
                  title={intl.formatMessage({ id: 'user_edit' })}
                  type="75bianji"
                />
              </OperateSpan>
              <OperateSpan onClick={() => this.deleteData(record)}>
                <IconTip
                  title={intl.formatMessage({ id: 'user_delete' })}
                  type="shanchu"
                />
              </OperateSpan>
            </div>
          );
        }
      }
    ];
    return (
      <div className="grade-tab">
        <Table
          rowKey={r => r.id}
          columns={gradeColumns}
          dataSource={serviceLevels}
          pagination={false}
        />
      </div>
    );
  };

  /**
   * 添加|编辑服务等级弹框
   * @returns {*}
   */
  gradeModal = () => {
    const { intl, dispatch, svcEditObj, allServiceItems = [] } = this.props;
    const serviceColumns = [
      {
        title: intl.formatMessage({ id: 'service_item_name' }),
        dataIndex: 'name',
        key: 'name',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_Exchange_describe' }),
        dataIndex: 'describeRemark',
        key: 'describeRemark',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_price' }),
        dataIndex: 'price',
        key: 'price',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_unit' }),
        dataIndex: 'unit',
        key: 'unit',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_type' }),
        dataIndex: 'type',
        key: 'type',
        width: '20%',
        render: text => <span>{text.name}</span>
      }
    ];
    let keys = [];
    svcEditObj.svcs && svcEditObj.svcs.map(s => keys.push(String(s.id)));
    const rowSelection = {
      selectedRowKeys: keys,
      onChange: (selectedRowKeys, selectedRows) => {
        svcEditObj.svcs = selectedRows;
        dispatch({ type: 'account/update', payload: svcEditObj });
      }
    };
    return (
      <div className="service-manage-modal">
        <div className="manage-row">
          <span className="prefix-title">
            <i className="iconfont icon-bitian" />
            {intl.formatMessage({ id: 'service_level' })} :
          </span>
          <Input
            maxLength="10"
            value={svcEditObj.name || ''}
            onChange={e => {
              svcEditObj.name = e.target.value;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_Exchange_describe' })} :{' '}
          </span>
          <Input
            maxLength="200"
            value={svcEditObj.remark || ''}
            onChange={e => {
              svcEditObj.remark = e.target.value;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_need_approve' })} :{' '}
          </span>
          <Switch
            checked={svcEditObj.auditType === SVC_AUDIT_TYPE.yes}
            onChange={checked => {
              svcEditObj.auditType = checked
                ? SVC_AUDIT_TYPE.yes
                : SVC_AUDIT_TYPE.no;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-table-row">
          <span className="prefix-title">
            <i className="iconfont icon-bitian" />
            {intl.formatMessage({ id: 'service_item_select' })} :
          </span>
          <div className="service-table">
            <Table
              rowKey={r => String(r.id)}
              columns={serviceColumns}
              dataSource={allServiceItems}
              rowSelection={rowSelection}
              pagination={false}
            />
          </div>
        </div>
      </div>
    );
  };

  /**
   * 服务项tab
   * @returns {*}
   */
  itemTab = () => {
    const { intl, dispatch, serviceItems } = this.props;
    const { list = [], total = 0, pageNo = 0, pageSize = 10 } = serviceItems;
    const itemColumns = [
      {
        title: intl.formatMessage({ id: 'service_item_item' }),
        dataIndex: 'name',
        key: 'name',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_Exchange_describe' }),
        dataIndex: 'describeRemark',
        key: 'describeRemark',
        width: '20%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_price' }),
        dataIndex: 'price',
        key: 'price',
        width: '10%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_unit' }),
        dataIndex: 'unit',
        key: 'unit',
        width: '10%'
      },
      {
        title: intl.formatMessage({ id: 'service_item_type' }),
        dataIndex: 'type',
        key: 'type',
        width: '10%',
        render: text => <span>{text.name}</span>
      },
      {
        title: intl.formatMessage({ id: 'service_item_if_number' }),
        dataIndex: 'countState',
        key: 'countState',
        width: '10%',
        render: text => (
          <span>
            {Number(text) === 0
              ? intl.formatMessage({ id: 'yes' })
              : intl.formatMessage({ id: 'no' })}
          </span>
        )
      },
      {
        title: intl.formatMessage({ id: 'service_item_if_remark' }),
        dataIndex: 'describeState',
        key: 'describeState',
        width: '10%',
        render: (text, record) => {
          let content = intl.formatMessage({ id: 'no' });
          if (Number(text) === 0) {
            content = record.describe || intl.formatMessage({ id: 'yes' });
          }
          return <span>{content}</span>;
        }
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_operation' }),
        dataIndex: 'operation',
        key: 'operation',
        width: '10%',
        render: (text, record) => {
          return (
            <div className="user-operate">
              <OperateSpan onClick={() => this.showModal(record)}>
                <IconTip
                  title={intl.formatMessage({ id: 'user_edit' })}
                  type="75bianji"
                />
              </OperateSpan>
              <OperateSpan onClick={() => this.deleteData(record)}>
                <IconTip
                  title={intl.formatMessage({ id: 'user_delete' })}
                  type="shanchu"
                />
              </OperateSpan>
            </div>
          );
        }
      }
    ];
    const pagination = {
      current: pageNo,
      total: total,
      onChange: page => {
        dispatch({
          type: 'account/getAllSvc',
          payload: { pageNo: page, pageSize: pageSize }
        });
      }
    };
    return (
      <div className="item-tab">
        <Table
          rowKey={r => r.id}
          columns={itemColumns}
          dataSource={list}
          pagination={pagination}
        />
      </div>
    );
  };

  /**
   * 添加|编辑服务项弹框
   * @returns {*}
   */
  itemModal = () => {
    const { intl, dispatch, svcEditObj, serviceTypes = [] } = this.props;
    let typeOptions = [];
    serviceTypes.map(t => {
      typeOptions.push(
        <Option key={String(t.id)} obj={t}>
          {t.name}
        </Option>
      );
    });
    return (
      <div className="service-manage-modal">
        <div className="manage-row">
          <span className="prefix-title">
            <i className="iconfont icon-bitian" />
            {intl.formatMessage({ id: 'service_item_name' })} :
          </span>
          <Input
            maxLength="10"
            value={svcEditObj.name || ''}
            onChange={e => {
              svcEditObj.name = e.target.value;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_Exchange_describe' })} :{' '}
          </span>
          <Input
            maxLength="200"
            value={svcEditObj.describeRemark || ''}
            onChange={e => {
              svcEditObj.describeRemark = e.target.value;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            <i className="iconfont icon-bitian" />
            {intl.formatMessage({ id: 'service_item_price' })} :{' '}
          </span>
          <div className="manage-content-inline">
            <Input
              className="manage-input-inline"
              style={{ textAlign: 'right' }}
              maxLength="10"
              value={svcEditObj.price || ''}
              placeholder={intl.formatMessage({
                id: 'service_item_price_format'
              })}
              onChange={e => {
                let value = e.target.value;
                let reg = /^[0-9]*([.]?[0-9]{0,2})$/;
                if (value !== '' && !reg.test(value)) return;
                svcEditObj.price = value;
                dispatch({ type: 'account/update', payload: svcEditObj });
              }}
            />
            <span className="manage-span-inline">
              <i className="iconfont icon-bitian" />
              {intl.formatMessage({ id: 'service_item_unit' })} :{' '}
            </span>
            <Input
              className="manage-input-inline"
              maxLength="10"
              value={svcEditObj.unit || ''}
              onChange={e => {
                svcEditObj.unit = e.target.value;
                dispatch({ type: 'account/update', payload: svcEditObj });
              }}
            />
            <span className="manage-span-inline">
              <i className="iconfont icon-bitian" />
              {intl.formatMessage({ id: 'service_item_type' })} :{' '}
            </span>
            <Select
              className="manage-input-inline"
              value={svcEditObj.type ? String(svcEditObj.type.id) : ''}
              onSelect={(v, o) => {
                svcEditObj.type = o.props.obj;
                dispatch({ type: 'account/update', payload: svcEditObj });
              }}
            >
              {typeOptions}
            </Select>
          </div>
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_need_number' })} :{' '}
          </span>
          <Switch
            checked={Number(svcEditObj.countState) === 0}
            onChange={checked => {
              svcEditObj.countState = checked ? 0 : 1;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
          <span style={{ color: '#999' }}>
            {intl.formatMessage({ id: 'service_need_number_explain' })}
          </span>
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_need_remark' })} :{' '}
          </span>
          <Switch
            checked={Number(svcEditObj.describeState) === 0}
            onChange={checked => {
              svcEditObj.describeState = checked ? 0 : 1;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
          <span style={{ color: '#999' }}>
            {intl.formatMessage({ id: 'service_need_remark_explain' })}
          </span>
        </div>
        <div className="manage-row">
          <span className="prefix-title" />
          {Number(svcEditObj.describeState) === 0 && (
            <i className="iconfont icon-bitian" />
          )}
          <Input
            maxLength="200"
            value={svcEditObj.describe || ''}
            placeholder={intl.formatMessage({
              id: 'service_need_describe_explain'
            })}
            onChange={e => {
              svcEditObj.describe = e.target.value;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            {intl.formatMessage({ id: 'service_need_upload_attachments' })} :{' '}
          </span>
          <Switch
            checked={Number(svcEditObj.uploadState) === 0}
            onChange={checked => {
              svcEditObj.uploadState = checked ? 0 : 1;
              dispatch({ type: 'account/update', payload: svcEditObj });
            }}
          />
          <span style={{ color: '#999' }}>
            {intl.formatMessage({
              id: 'service_need_upload_attachments_attention'
            })}
          </span>
        </div>
      </div>
    );
  };

  /**
   * 添加|编辑按钮
   */
  submit = () => {
    const { activeKey } = this.state;
    const { dispatch } = this.props;
    if (activeKey === GRADE_TAB) {
      dispatch({ type: 'account/setSvcLevel' });
    } else if (activeKey === ITEM_TAB) {
      dispatch({ type: 'account/setService' });
    }
  };

  /**
   * 删除服务等级|服务项
   * @param obj
   */
  deleteData = obj => {
    const { activeKey } = this.state;
    const { intl, dispatch } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'service_delete_data' }),
      onOk: () => {
        if (activeKey === GRADE_TAB) {
          dispatch({ type: 'account/deleteLevel', id: obj.id });
        } else if (activeKey === ITEM_TAB) {
          dispatch({ type: 'account/delSvc', id: obj.id });
        }
      }
    });
  };

  showModal = svcEditObj => {
    this.props.dispatch({
      type: 'account/update',
      payload: {
        serviceModal: true,
        svcEditObj: _.cloneDeep(svcEditObj)
      }
    });
  };

  closeModal = () => {
    this.props.dispatch({
      type: 'account/update',
      payload: { serviceModal: false }
    });
  };
}

export default ServiceManager;



// WEBPACK FOOTER //
// ./src/components/account/ServiceManager.js